import { useOpsContext } from './useOpsContext';
import { useOpsBriefingAccess } from '../../services/useOpsBriefingService';

/**
 * 강사 성과 리포트 진입점을 보여도 되는가.
 *
 * ─────────────────────────────────────────────────────────────
 * 왜 훅 하나로 감싸나
 * ─────────────────────────────────────────────────────────────
 * 리포트 버튼이 운영 브리핑 **밖**(강사 관리·센터 리포트)에도 생겼습니다.
 * 그 화면들은 운영 브리핑의 라우트 가드 밖이라, 판정을 직접 해야 합니다.
 * 그때마다 `useOpsContext` → `useOpsBriefingAccess` → `allowed` 를 손으로
 * 이어 붙이면 어느 화면 하나가 `isResolving` 을 잘못 보거나 `data.enabled` 를
 * 직접 들여다보는 날이 옵니다. 판정 규칙은 한 줄로 줄여 둡니다.
 *
 * ⚠️ `allowed` 만 봅니다.
 * 판정 전에도 false 라 버튼이 잠깐 안 보였다가 나타납니다. 그게 맞습니다 —
 * 진입점은 늦게 보여도 해가 없지만, 닫힌 센터에서 잘못 열리면 리포트가 쓰는
 * 조회 아홉 개가 전부 404 로 떨어져 원장이 고장 난 화면을 봅니다.
 * (accessGate.ts · Gnb.tsx 가 쓰는 것과 같은 규칙입니다)
 */
export const useCoachReportAccess = (): boolean => {
    const ctx = useOpsContext();
    const { allowed } = useOpsBriefingAccess(ctx);
    return allowed;
};
